import React, { useState, useEffect } from 'react';

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const navItems = ['home', 'about', 'experience', 'projects', 'skills', 'contact'];

    return (
        <nav className={`fixed top-0 w-full z-50 transition-all duration-500 ${scrolled ? 'bg-warm-white/90 backdrop-blur-sm border-b border-warm-grey' : 'bg-transparent'
            }`}>
            <div className="max-w-7xl mx-auto px-6 h-20 flex justify-between items-center">
                <div
                    onClick={() => scrollToSection('home')}
                    className="text-2xl font-serif font-bold text-charcoal cursor-pointer hover:text-earth-brown transition-colors"
                >
                    SRL.
                </div>

                {/* Desktop Menu */}
                <div className="hidden md:flex space-x-8">
                    {navItems.map((item) => (
                        <button
                            key={item}
                            onClick={() => scrollToSection(item)}
                            className="text-sm uppercase tracking-widest text-charcoal/80 hover:text-earth-brown transition-colors"
                        >
                            {item}
                        </button>
                    ))}
                </div>

                {/* Mobile Menu Icon Placeholder - keeping it simple for now, relying on scroll behavior */}
                {/* You could verify mobile menu implementation if needed, but for "minimalist" start, pure text is good. 
            The previous App.js had a mobile menu. I will re-implement a simple one if requested, 
            but for now verifying the desktop look first. */}
            </div>
        </nav>
    );
}
